import { PayloadAction } from '@reduxjs/toolkit';

import { FontState, UploadedFontData } from 'editor/src/store/fonts/types';

const setUploadedFontsReducer = (state: FontState, action: PayloadAction<UploadedFontData[]>) => {
  state.uploadedFonts = action.payload;
  state.uploadedFontsReceived = true;
};

export default setUploadedFontsReducer;
